const MuiInputAdornmentOverrides = {
  MuiInputAdornment: {
    styleOverrides: {
      root: ({
        theme
      }) => ({
        color: theme.palette.text.primary
      })
    }
  }
};

export { MuiInputAdornmentOverrides };
